
<div class="Section TSEComplianceSection" id="tse-compliance">
    <div class="SectionContainer">
        <div class="TSEHeader">
            <div class="TSEBadge">
                <i class="ri-shield-check-line"></i>
                <span>2026 Pflicht</span>
            </div>
            <h2 class="SectionTitle">
                <span class="TitleAccent">TSE-Konformität</span>
                für Taxi- und Mietwagenunternehmen
            </h2>
            <p class="TSESubtitle">
                Ab dem 1. Januar 2026 ist TSE-Konformität gesetzlich vorgeschrieben. Wir machen
                es einfach – automatisch und zuverlässig.
            </p>
        </div>

        <div class="TSEContent">
            <div class="TSEGrid">
                <div class="TSECard">
                    <div class="CardIcon">
                        <i class="ri-calendar-check-line"></i>
                    </div>
                    <div class="CardContent">
                        <h3>Countdown bis 2026</h3>
                        <div class="Countdown">
                            <div class="CountdownItem">
                                <span class="CountdownNumber">{{ daysUntil2026 }}</span>
                                <span class="CountdownLabel">Tage</span>
                            </div>
                        </div>
                        <p>
                            Die Zeit drängt. Bereiten Sie sich jetzt vor, um ab Januar 2026 ohne
                            Unterbrechung weiterzuarbeiten.
                        </p>
                    </div>
                </div>
                <div class="TSECard">
                    <div class="CardIcon">
                        <i class="ri-error-warning-line"></i>
                    </div>
                    <div class="CardContent">
                        <h3>Risiko ohne TSE</h3>
                        <div class="RiskList">
                            <div class="RiskItem">
                                <i class="ri-close-circle-line"></i>
                                <span>Bußgelder bis zu 25.000€</span>
                            </div>
                            <div class="RiskItem">
                                <i class="ri-close-circle-line"></i>
                                <span>Betriebsverbot</span>
                            </div>
                            <div class="RiskItem">
                                <i class="ri-close-circle-line"></i>
                                <span>Lizenzverlust</span>
                            </div>
                        </div>
                        <p>Ohne TSE-konforme Lösung riskieren Sie Ihren gesamten Betrieb.</p>
                    </div>
                </div>

                <div class="TSECard">
                    <div class="CardIcon">
                        <i class="ri-shield-check-line"></i>
                    </div>
                    <div class="CardContent">
                        <h3>Mit TaxiFusion TSE</h3>
                        <div class="BenefitList">
                            <div class="BenefitItem">
                                <i class="ri-checkbox-circle-line"></i>
                                <span>100% rechtssicher</span>
                            </div>
                            <div class="BenefitItem">
                                <i class="ri-checkbox-circle-line"></i>
                                <span>Automatische Konformität</span>
                            </div>
                            <div class="BenefitItem">
                                <i class="ri-checkbox-circle-line"></i>
                                <span>Zukunftssicher</span>
                            </div>
                        </div>
                        <p>
                            TSE-Konformität ohne zusätzlichen Aufwand für Taxi- und
                            Mietwagenunternehmen. Wir erledigen alles automatisch.
                        </p>
                    </div>
                </div>
            </div>

            <div class="TSECTA">
                <h3>Bereit für TSE-Konformität?</h3>
                <p>
                    Sichern Sie sich jetzt TSE-Konformität für Ihr Taxi- oder
                    Mietwagenunternehmen und vermeiden Sie Bußgelder. Kontaktieren Sie uns für
                    eine kostenlose Beratung.
                </p>
                <router-link to="/register" class="TSEButton">
                    <SiteButton>
                        <span>TSE-konform mit uns</span>
                        <i class="ri-arrow-right-line"></i>
                    </SiteButton>
                </router-link>
            </div>
        </div>
    </div>
</div>
